export default "__VITE_ASSET__gNVAiOTC__"